export const CACHE_SIZE: number = 200;
export const LLT_EXPIRED: number = -1;
// time to live defaults to 2 hours
export const DEFAULT_TTL: number = 2 * 60 * 60 * 1000;
